import {
  EndpointNames,
  Pages,
  RequestMethod
} from '@vio/debug-panel/src/types/enums'
import {ScenarioMetadata} from '@vio/debug-panel/src/types/types'

export const metadata: ScenarioMetadata = {
  scope: 'permanent',
  name: 'Offer-Check on AP',
  value: 'OfferCheck',
  description: 'Testing different scenarios of alternative offers behavior',
  routes: [
    /**
     * Regular offer
     */
    {
      endpoint: EndpointNames.OfferCheck,
      method: RequestMethod.GET,
      page: Pages.AP,
      variations: [
        {
          value: 'soldOutAPRegular',
          displayName: 'Clicked offer is sold out (AP, regular offer)',
          description:
            'When user clicks on a room-offer, called offer-check returns a default sold-out response'
        },
        {
          value: 'delayedAP',
          displayName: 'Delay offer-check response (AP, regular offer)',
          description:
            'When user clicks on a room-offer, called offer-check returns a backend response with a minimum delay time (in ms), control delay with &delay= url param, by default falls back to 4000ms'
        }
      ]
    },
    {
      endpoint: EndpointNames.OfferCheck,
      method: RequestMethod.GET,
      page: Pages.SRP,
      variations: [
        {
          value: 'soldOutSRPRegular',
          displayName: 'Clicked offer is sold out (SRP, regular offer)',
          description:
            'When user clicks on a room-offer, called offer-check returns a default sold-out response'
        },
        {
          value: 'delayedSRP',
          displayName: 'Delay offer-check response (SRP, regular offer)',
          description:
            'When user clicks on a room-offer, called offer-check returns a backend response with a minimum delay time (in ms), control delay with &delay= url param, by default falls back to 4000ms'
        }
      ]
    }
  ]
}
